import React, { useEffect, useState } from "react";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import Stack from "components/common/Stack";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Button from "components/common/Button";
import MenuItem from "components/common/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Select from "@mui/material/Select";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DropzoneArea } from "react-mui-dropzone";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import OutlinedInput from "@mui/material/OutlinedInput";

const AddStationForm = ({
  props,
  onSubmit,
  onChange,
  formData,
  onImageChange,
  addFieldsAddChargingConnector,
  handleAddConnnector,
  formError,
  inputFields,
  handleChangeAddChargingPoint,
  removeFieldsChargingPoint,
  addFieldsAddChargingPoint,
  handleChangeAddChargingConnector,
  removeFieldsChargingConnector,
  networkDropdown
}) => {
  const [timeFormat, setTimeFormat] = useState("24hr");

  const handleTimeFormatChange = (event) => {
    setTimeFormat(event.target.value);
    if (event.target.value === "24hr") {
      let date = new Date();
      let Closedate = new Date();
      date.setHours(0, 0, 0, 0);
      onChange("open_time", date);
      Closedate.setHours(23, 59, 59, 59);
      onChange("close_time", Closedate);
    }
  };
  useEffect(() => {
    let date = new Date();
    let Closedate = new Date();
    date.setHours(0, 0, 0, 0);
    onChange("open_time", date);
    Closedate.setHours(23, 59, 59, 59);
    onChange("close_time", Closedate);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const classes = useStyles();
  var amenities = props.amenitiesData;
  var network = props.networkData;
  var chargerType = props.chargerTypes;


  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const iconData = [];
  iconData.src = "../Group 20449/Group 20158.svg";

  return (
    <Box className={classes.center}>
      <Card>
        <CardContent>
          <Text
            variant="h5"
            color="#707070"
            sx={{ fontSize: "22px", fontWeight: "bold", marginBottom: "40px" }}
          >
            <ArrowBackIcon
              sx={{ fontSize: "22px", fontWeight: "bold", marginRight: "10px",cursor:'pointer' }}
              onClick={() => handleAddConnnector("back")}
            />
            Add Station
          </Text>
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{
              marginBottom: "1.25rem",
            }}
          >
            <Grid container columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}>
              <Grid item xs={12} sm={12} md={2} lg={3}>
                <Text variant="body1" className={classes.formHeading}>
                  BASIC DETAILS
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={9}>
                <Box className={classes.form_container}>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    label="Name of charging station"
                    value={formData.name}
                    onChange={(e) => onChange("name", e.target.value)}
                    helperText={formError.name}
                    error={formError.name}
                    InputLabelProps={{
                      style: { fontSize: 16, color: "#9e9e9e" },
                    }}
                    inputProps={{
                      style: { textTransform: "capitalize", fontSize: "14px" },
                      maxLength: 30,
                      minLength: 30,
                      pattern: "^[A-Za-z0-9]*$",
                      title: "Only letters and numbers are allowed",
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/^[\s]+|[^A-Za-z0-9 ]/g, ''); 
                    }}
                  />

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Email id"
                        onChange={(e) => onChange("email", e.target.value)}
                        value={formData.email}
                        helperText={formError.email}
                        error={formError.email}
                        variant="outlined"
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        inputProps={{
                          style: {
                            textTransform: "lowercase",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                          minLength: 50,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/^\s+/, '');
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Contact Number"
                        onChange={(e) => onChange("mobile", e.target.value)}
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 10,
                          minLength: 10,
                        }}
                        variant="outlined"
                        style={{ marginTop: "1.25rem" }}
                        value={formData.mobile}
                        error={formError.mobile}
                        helperText={formError.mobile}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/^\s+|[^0-9]/g, ''); 
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Box style={{ marginTop: "1.25rem" }}>
                    <FormControl fullWidth size="small">
                      <InputLabel
                        sx={{ fontSize: "15px", color: "#9e9e9e" }}
                        id="demo-simple-select-label"
                      >
                        Select type of network
                      </InputLabel>

                      <Select
                        sx={{ fontSize: "15px" }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Select type of network"
                        value={formData.network_id}
                        onChange={(e) => onChange("network_id", e.target.value)}
                      >
                        {networkDropdown?.map((network, i) => (
                          <MenuItem
                            sx={{ fontSize: "14px" }}
                            value={network.id}
                            key={i}
                          >
                            {network.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <FormControl
                    sx={{
                      top: "1.25rem",
                      marginBottom: "2.25rem",
                      width: "100% !important",
                    }}
                  >
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{
                        marginBottom: "10px",
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "#1e1e1e",
                      }}
                    >
                      Type of Charging Station
                    </FormLabel>
                    <RadioGroup
                      row
                      value={formData.type}
                      onChange={(e) => onChange("type", e.target.value)}
                    >
                      <FormControlLabel
                        sx={{
                          ".MuiFormControlLabel-label": {
                            position: "relative",
                            margin: "auto",
                            fontSize: "15px",
                            color: "#9e9e9e",
                          },
                        }}
                        style={{
                          marginLeft: "0",
                          marginRight: "10%",
                          padding: "10px 0px",
                          border: "1px solid #e0e0e0",
                        }}
                        className={classes.form_option}
                        value="public"
                        control={
                          <Radio
                            sx={{
                              "&.Mui-checked": {
                                color: "#6c757d",
                              },
                            }}
                          />
                        }
                        label="Public"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        sx={{
                          ".MuiFormControlLabel-label": {
                            position: "relative",
                            margin: "auto",
                            fontSize: "15px",
                            color: "#9e9e9e",
                          },
                        }}
                        style={{
                          marginLeft: "0",
                          padding: "10px 0px",
                          border: "1px solid #e0e0e0",
                        }}
                        className={classes.form_option}
                        value="private"
                        control={
                          <Radio
                            sx={{
                              "&.Mui-checked": {
                                color: "#6c757d",
                              },
                            }}
                          />
                        }
                        labelPlacement="start"
                        label="Private"
                      />
                    </RadioGroup>
                  </FormControl>

                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{
                      marginBottom: "10px",
                      marginTop: "1.25rem",
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "#1e1e1e",
                    }}
                  >
                    Working Hours
                  </FormLabel>
                  <FormControl fullWidth style={{ marginTop: "1.25rem" }}>
                    <InputLabel id="time-format-label">Time Format</InputLabel>
                    <Select
                      size="small"
                      labelId="time-format-label"
                      value={timeFormat}
                      label="Time Format"
                      onChange={handleTimeFormatChange}
                    >
                      <MenuItem value="24hr">24 Hours</MenuItem>
                      <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                  </FormControl>

                  {timeFormat === "custom" && (
                    <LocalizationProvider
                      style={{ marginTop: "1.25rem" }}
                      dateAdapter={AdapterDateFns}
                    >
                      <Grid
                        style={{ marginTop: "1.25rem" }}
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={5}>
                          <TimePicker
                            label="Open Time"
                            onChange={(e) => onChange("open_time", e)}
                            value={formData.open_time}
                            inputProps={{ style: { fontSize: "14px" } }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <FormLabel
                            id="demo-row-radio-buttons-group-label"
                            sx={{ margin: "1rem" }}
                          >
                            to
                          </FormLabel>
                        </Grid>
                        <Grid item xs={5}>
                          <TimePicker
                            label="Close Time"
                            value={formData.close_time}
                            inputProps={{ style: { fontSize: "14px" } }}
                            onChange={(e) => onChange("close_time", e)}
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                  )}
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{
                      marginBottom: "10px",
                      marginTop: "1.25rem",
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "#1e1e1e",
                    }}
                  >
                    Charging Station URL
                  </FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    label="Charging station URL"
                    variant="outlined"
                    onChange={(e) => onChange("station_url", e.target.value)}
                    value={formData.station_url}
                    helperText={formError.station_url}
                    error={formError.station_url}
                    style={{ marginTop: "1.25rem" }}
                    InputLabelProps={{
                      style: { fontSize: 16, color: "#9e9e9e" },
                    }}
                    inputProps={{ style: { fontSize: "14px" } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={3}>
                <Text variant="body1" className={classes.formHeading}>
                  AMENITIES
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={10} lg={9}>
                <Box className={classes.form_container}>
                  <Box>
                    <FormControl fullWidth size="small">
                      <InputLabel
                        sx={{ fontSize: "16px", color: "#9e9e9e" }}
                        id="demo-multiple-checkbox-label"
                      >
                        Select Amenity
                      </InputLabel>
                      <Select
                        sx={{ fontSize: "14px" }}
                        labelId="demo-multiple-checkbox-label"
                        id="amenity"
                        multiple
                        value={formData.amenities}
                        input={<OutlinedInput label="Select Amenity" />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                        onChange={(e) => onChange("amenities", e.target.value)}
                        size="small"
                      >
                        {amenities?.map((amenity, index) => (
                          <MenuItem
                            sx={{ fontSize: "14px" }}
                            key={index}
                            value={amenity.name}
                          >
                            <Checkbox
                              size="small"
                              checked={
                                formData.amenities
                                  ? formData.amenities.indexOf(amenity.name) >
                                    -1
                                  : false
                              }
                            />
                            <ListItemText
                              style={{ fontSize: "14px" }}
                              primary={amenity.name}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={3}>
                <Text variant="body1" className={classes.formHeading}>
                  ADD CHARGING POINT
                </Text>
              </Grid>

              <Grid item xs={12} sm={12} md={10} lg={9}>
                {inputFields?.map((input, index) => (
                  <div key={index}>
                    {index === inputFields.length - 1 ? (
                      index === 0 ? (
                        ""
                      ) : (
                        <Text>
                          <HighlightOffIcon
                            sx={{
                              color: "orange",
                              cursor: "pointer",
                              position: "absolute",
                              margin: "-3.5px 0 0 2rem",
                            }}
                            onClick={() => removeFieldsChargingPoint(index)}
                          />
                        </Text>
                      )
                    ) : (
                      ""
                    )}

                    <Text
                      sx={{
                        marginLeft: "12px",
                        margin: "1.6rem  0 0 4rem",
                        fontSize: "15px",
                        fontWeight: "600",
                      }}
                    >
                      Charging Point {index + 1}
                    </Text>

                    <Box
                      sx={{
                        width: "20px",
                        height: "20px",
                        background: "#19AA69",
                        borderRadius: "50px 50px",
                        textAlign: "center",
                        color: "#ffff",
                        fontSize: "12.5px",
                        cursor: "pointer",
                        margin: "-20px 0 0 12rem ",
                      }}
                      onClick={() => addFieldsAddChargingPoint()}
                    >
                      +
                    </Box>

                    <Box className={classes.form_container}>
                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            label="Charging Point Name"
                            variant="outlined"
                            name="name"
                            onChange={(event) => {
                              handleChangeAddChargingPoint(index, event);
                            }}
                            inputProps={{ style: { fontSize: "14px" } }}
                            InputLabelProps={{
                              style: { fontSize: 14, color: "#9e9e9e" },
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value.trimStart();
                            }}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            label="Charging Point ID"
                            variant="outlined"
                            name="cp_id"
                            onChange={(event) => {
                              handleChangeAddChargingPoint(index, event);
                            }}
                            inputProps={{
                              style: { fontSize: "14px" },
                              pattern: "[0-9]+([.,][0-9]*)?",
                              title: "Only numbers and decimal points are allowed",
                            }}
                            InputLabelProps={{
                              style: { fontSize: 16, color: "#9e9e9e" },
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
                            }}
                            size="small"
                          />

                        </Grid>


                        <Grid>
                          <Box className="App">
                            {input.connectors?.map((input2, j) => (
                              <div key={j}>
                                {j === input?.connectors?.length - 1 ? (
                                  j === 0 ? (
                                    ""
                                  ) : (
                                    <HighlightOffIcon
                                      sx={{
                                        color: "orange",
                                        cursor: "pointer",
                                        position: "absolute",
                                        marginTop: "-2px",
                                      }}
                                      onClick={() =>
                                        removeFieldsChargingConnector(index, j)
                                      }
                                    />
                                  )
                                ) : (
                                  ""
                                )}

                                <Text
                                  sx={{
                                    marginLeft: "12px",
                                    margin: "1.5rem 0 0 2rem",
                                    fontSize: "15px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Charging Connector {j + 1}
                                </Text>

                                <FormControl fullWidth size="small">
                                  <Box
                                    sx={{ display: "flex", marginLeft: "20px" }}
                                  >
                                    <InputLabel
                                      sx={{
                                        margin: "10px 25px",
                                        padding: "0px",
                                        fontSize: "14px",
                                      }}
                                      id={index}
                                      name="chargingConnector"
                                    >
                                      Charging Connector
                                    </InputLabel>
                                    <Select
                                      sx={{
                                        margin: "10px 10px",
                                        width: "340px",
                                        padding: "0px",
                                        height: "40px",
                                        border: "0px solid gray",
                                        borderRadius: "5px",
                                      }}
                                      labelId="demo-simple-select-label"
                                      name="charger_type_id"
                                      label="Charging Connector"
                                      onChange={(event) =>
                                        handleChangeAddChargingConnector(
                                          index,
                                          event,
                                          j
                                        )
                                      }
                                    >
                                      {chargerType?.map((chargerTypes) => (
                                        <MenuItem
                                          sx={{ fontSize: "14px" }}
                                          value={chargerTypes.id}
                                          key={chargerTypes.id}
                                        >
                                          {chargerTypes.name} ({chargerTypes.type})
                                        </MenuItem>
                                      ))}
                                    </Select>

                                    <TextField
                                      sx={{ margin: "10px 0 0 1rem" }}
                                      className={classes.textField}
                                      size="small"
                                      id="capacity"
                                      name="power"
                                      label="Power (kw)"
                                      InputLabelProps={{
                                        style: { fontSize: 14 },
                                      }}
                                      inputProps={{
                                        style: { fontSize: "14px" },
                                        pattern: "[0-9]+([.,][0-9]*)?",
                                        title: "Only numbers and decimal points are allowed",
                                      }}
                                      onChange={(event) => {
                                        handleChangeAddChargingConnector(
                                          index,
                                          event,
                                          j
                                        );
                                      }}
                                    
                                      variant="outlined"
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
                                      }}
                                    />
                                    <TextField
                                      sx={{ margin: "10px 0 0 1rem" }}
                                      className={classes.textField}
                                      size="small"
                                      id="rate"
                                      name="price_per_khw"
                                      label="Rate (&#8377;)"
                                      variant="outlined"
                                      InputLabelProps={{
                                        style: { fontSize: 14 },
                                      }}
                                      inputProps={{
                                        style: { fontSize: "14px" },
                                        pattern: "[0-9]+([.,][0-9]*)?",
                                        title: "Only numbers and decimal points are allowed",
                                      }}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
                                      }}
                                     
                                      onChange={(event) => {
                                        handleChangeAddChargingConnector(
                                          index,
                                          event,
                                          j
                                        );
                                      }}
                                      value={input.price_per_kwh}
                                    />
                                  </Box>
                                </FormControl>
                              </div>
                            ))}
                            <Text
                              sx={{
                                cursor: "pointer",
                                color: "#19AA69",
                                fontSize: "14px",
                                margin: "5px 30px",
                              }}
                              onClick={() =>
                                addFieldsAddChargingConnector(index)
                              }
                            >
                              +Add Charging Connector
                            </Text>
                          </Box>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      ></Grid>
                    </Box>
                  </div>
                ))}
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={3}>
                <Text variant="body1" className={classes.formHeading}>
                  ADDRESS DETAILS
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={10} lg={9}>
                <Box className={classes.form_container}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Address 1"
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    onChange={(e) => onChange("address", e.target.value)}
                    inputProps={{ style: { fontSize: "14px" } }}
                    value={formData.address}
                    error={formError.address}
                    helperText={formError.address}
                    multiline
                    rows={4}
                    fullWidth
                    InputLabelProps={{
                      style: { fontSize: 16, color: "#9e9e9e" },
                    }}
                  />

                  <TextField
                    id="outlined-multiline-static"
                    label="Address 2"
                    sx={{
                      backgroundColor: "#ffffff",
                    }}
                    onChange={(e) => onChange("address2", e.target.value)}
                    inputProps={{ style: { fontSize: "14px" } }}
                    multiline
                    rows={4}
                    fullWidth
                    style={{ marginTop: "1.25rem" }}
                    InputLabelProps={{
                      style: { fontSize: 16, color: "#9e9e9e" },
                    }}
                  />

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Landmark"
                        variant="outlined"
                        onChange={(e) => onChange("landmark", e.target.value)}
                        value={formData.landmark}
                        helperText={formError.landmark}
                        error={formError.landmark}
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        inputProps={{ style: { fontSize: "14px" } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Pin code"
                        variant="outlined"
                        onChange={(e) => onChange("pin", e.target.value)}
                        value={formData.pin}
                        error={formError.pin}
                        helperText={formError.pin}
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 6,
                          minLength: 6,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/^\s+/, '');
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Street"
                        variant="outlined"
                        onChange={(e) => onChange("street", e.target.value)}
                        value={formData.street}
                        error={formError.street}
                        helperText={formError.street}
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        inputProps={{ style: { fontSize: "14px" },
                          maxLength: 50,
                          minLength: 50,
                       }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="City"
                        onChange={(e) => onChange("city", e.target.value)}
                        value={formData.city}
                        error={formError.city}
                        helperText={formError.city}
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 30,
                          pattern: "^[A-Za-z]*$",
                          title: "Only alphabetic characters are allowed",
                        }}
                        variant="outlined"
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/^[\s]+|[^A-Za-z ]/g, '');
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Box style={{ marginTop: "1.25rem" }}>
                        <FormControl fullWidth>
                          <RegionDropdown
                            country={formData.country}
                            value={formData.state}
                            style={{
                              backgroundColor: "rgb(255, 255, 255)",
                              height: "38px",
                              color: "#9e9e9e",
                              fontSize: "16px",
                              padding: "8px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              border: "1px solid rgba(0, 0, 0, 0.3)",
                            }}
                            onChange={(e) => onChange("state", e)}
                          />
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Box style={{ marginTop: "1.25rem" }}>
                        <FormControl fullWidth>
                          <CountryDropdown
                            value={formData.country}
                            style={{
                              backgroundColor: "rgb(255, 255, 255)",
                              height: "38px",
                              color: "#9e9e9e",
                              fontSize: "16px",
                              padding: "8px",
                              borderRadius: "4px",
                              cursor: "pointer",
                              border: "1px solid rgba(0, 0, 0, 0.3)",
                            }}
                            onChange={(e) => onChange("country", e)}
                          />
                        </FormControl>
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Latitude"
                        variant="outlined"
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        onChange={(e) => onChange("latitude", e.target.value)}
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 10,
                          minLength: 10,
                        }}
                        value={formData.latitude}
                        error={formError.latitude}
                        helperText={formError.latitude}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Longitude"
                        variant="outlined"
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{
                          style: { fontSize: 16, color: "#9e9e9e" },
                        }}
                        onChange={(e) => onChange("longitude", e.target.value)}
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 10,
                          minLength: 10,
                        }}
                        value={formData.longitude}
                        error={formError.longitude}
                        helperText={formError.longitude}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={3}>
                <Text variant="body1" className={classes.formHeading}>
                  PHOTOS OF CHARGING STATION
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={10} lg={9}>
                <Box className={classes.form_container}>
                  <DropzoneArea
                    dropzoneParagraphClass={classes.dropzone}
                    sx={{ color: "#E9E9E9", fontSize: "14px" }}
                    dropzoneText="Drag and drop here or Browse"
                    dropzoneClass={classes.dropzone}
                    Icon={() => (
                      <CloudUploadIcon
                        sx={{ color: "#E9E9E9", fontSize: "5.5rem" }}
                      />
                    )}
                    acceptedFiles={["image/jpeg", "image/png", "image/bmp"]}
                    onChange={(file) => onImageChange(file)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={3}></Grid>
              <Grid item xs={12} sm={12} md={10} lg={9}>
                <Box className={classes.form_container}>
                  <Button
                    sx={{ fontSize: "14px", width: "160px", height: "40px" }}
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({

  dropzone: {
    fontSize: "16px",
    padding: "15px",
  },
  form_option: {
    width: "45%",
    height: "20px",
  },
  formHeading: {
    fontSize: "16px",
    fontFamily: "Nunito Sans",
    fontWeight: "bold",
    color: "#1e1e1e",
    marginTop: "1.6rem",
  },

  form_container: {
    padding: "1.25rem",
    width: "50%",
    marginLeft: "5%",
    "@media (max-width:768px)": {
      padding: "1rem",
      width: "90%",
      margin: "auto",
    },
  },
}));
export default AddStationForm;